import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { ModalComponent } from '../../../modal/modal.component';
import { InspectionStatusPipe } from '../../../pipes';
import { InspectionFilter, Person } from '../../models';

@Component({
    selector: 'inspection-filter-modal',
    templateUrl: 'filterModal.component.html',
    standalone: false
})
export class InspectionFilterModalComponent extends BaseModalPageComponent {
  filter: InspectionFilter;
  people: Person[];
  productLines: any[];
  statusList: any[];
  localEntities: any[];
  equipmentTypes: any[];
  statuses: any[];
  selectedPerson: Person;
  @ViewChild('localEntitiesModal', { static: true }) localEntitiesModal: ModalComponent;
  @ViewChild('peopleModal', { static: true }) peopleModal: ModalComponent;
  @ViewChild('statusModal', { static: true }) statusModal: ModalComponent;
  @ViewChild('productLinesModal', { static: true }) productLinesModal: ModalComponent;
  @ViewChild('equipmentTypesModal', { static: true }) equipmentTypesModal: ModalComponent;

  constructor(
    public selfModal: ModalComponent,
    location: Location,
    private inspectionStatusPipe: InspectionStatusPipe
  ) {
    super(location);
  }

  public init(data: any) {
    Object.assign(this, data);
    this.statuses = this.statusList.map((s) => ({ label: this.inspectionStatusPipe.transform(s), value: s }));
    this.selectedPerson = this.people.find((p) => p.id === this.filter.fst);
    this.productLines = this.productLines.map((p) => ({ label: p.name, value: p.id }));
    this.equipmentTypes = this.equipmentTypes.map((t) => ({ label: t.name, value: t.name }));
  }

  apply() {
    this.selfModal.close(true);
  }

  reset(form: NgForm) {
    form.reset();
    this.selfModal.close(true);
  }

  openPeopleSelector(): void {
    this.openSelector(
      this.peopleModal,
      this.people.map((person) => ({ label: person.name, value: person.id })),
      this.people.find((p) => p.id === this.filter.fst)?.id,
      { search: true, none: true }
    );
  }

  selectPeopleMenu(item: any) {
    this.selectedPerson = this.people.find((p) => p.id === item.selectedIndex);
    if (this.selectedPerson?.id === this.filter.fst) {
      this.filter.fst = '';
      this.selectedPerson = null;
    } else {
      this.filter.fst = this.selectedPerson?.id;
    }
  }

  openStatusSelector(): void {
    this.openSelector(this.statusModal, this.statuses, this.filter.status);
  }

  selectStatusMenu(item: any) {
    this.filter.status = item.selectedIndex === this.filter.status ? null : item.selectedIndex;
  }

  openProductLinesSelector(): void {
    this.openSelector(this.productLinesModal, this.productLines, this.filter.productLine);
  }

  selectProductLinesMenu(item: any) {
    this.filter.productLine = item.selectedIndex === this.filter.productLine ? '' : item.selectedIndex;
  }

  openEuqipmentTypeSelector(): void {
    this.openSelector(this.equipmentTypesModal, this.equipmentTypes, this.filter.equipmentType, {
      search: true,
      none: true
    });
  }

  selectEquipmentTypeMenu(item: any) {
    this.filter.equipmentType = item.selectedIndex === this.filter.equipmentType ? '' : item.selectedIndex;
  }

  openLocalEntitiesSelector(): void {
    this.openSelector(this.localEntitiesModal, this.localEntities, this.filter.localEntity, {
      search: true,
      none: true
    });
  }

  selectLocalEntitiesMenu(item: any) {
    this.filter.localEntity = item.selectedIndex === this.filter.localEntity ? '' : item.selectedIndex;
  }
}
